(() => {
  if (window.setaraProductCardQuickAddBound) return;
  window.setaraProductCardQuickAddBound = true;

  const playAddFabClick = (fab) => {
    fab.classList.remove('setara-product-card__quick-add-fab--clicked');
    void fab.offsetWidth;
    fab.classList.add('setara-product-card__quick-add-fab--clicked');
  };

  document.addEventListener('click', (event) => {
    const addFab = event.target.closest('[data-setara-add-to-cart-trigger]:not([disabled])');
    if (addFab) {
      event.preventDefault();
      event.stopPropagation();
      playAddFabClick(addFab);
      addFab.closest('.setara-product-card')?.querySelector('product-form form')?.requestSubmit();
      return;
    }

    const quickViewFab = event.target.closest('[data-setara-quick-view-trigger]:not([disabled])');
    if (!quickViewFab) return;

    event.preventDefault();
    event.stopPropagation();
    quickViewFab.closest('.setara-product-card')?.querySelector('modal-opener button:not([disabled])')?.click();
  });

  document.addEventListener(
    'animationend',
    (event) => {
      if (event.animationName !== 'setara-fab-add-click' && event.animationName !== 'setara-fab-add-click-reduced') {
        return;
      }

      event.target
        .closest?.('.setara-product-card__quick-add-fab--add')
        ?.classList.remove('setara-product-card__quick-add-fab--clicked');
    },
    true
  );
})();
